export const ROLE_VALUES = {
  FOUNDER: "FOUNDER",
  MANAGER: "MANAGER",
  TEAM_LEADER: "TEAM_LEADER",
  EMPLOYEE: "Employee",
};

export const ADMIN_ROLES = [
  ROLE_VALUES.FOUNDER,
  ROLE_VALUES.TEAM_LEADER,
 
  ROLE_VALUES.MANAGER,
];

const LEGACY_ROLE_MAP = {
  FOUNDER: ROLE_VALUES.FOUNDER,
  TEAM_LEADER: ROLE_VALUES.TEAM_LEADER,
  TEAMLEADER: ROLE_VALUES.TEAM_LEADER,
  TEAM_LEAD: ROLE_VALUES.TEAM_LEADER,
  MANAGER: ROLE_VALUES.MANAGER,
  EMPLOYEE: ROLE_VALUES.EMPLOYEE,
};

export function normalizeRole(role) {
  const key = String(role || "")
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[/-]/g, "_")
    .toUpperCase();
  return LEGACY_ROLE_MAP[key] || key || "";
}

export function formatRoleLabel(role) {
  const normalized = normalizeRole(role);
  switch (normalized) {
    case ROLE_VALUES.FOUNDER:
      return "founder";
    case ROLE_VALUES.TEAM_LEADER:
      return "team leader";
    case ROLE_VALUES.MANAGER:
      return "manager";
    case ROLE_VALUES.EMPLOYEE:
      return "employee";
    default:
      return String(role || "user");
  }
}

export function hasRole(userOrRole, role) {
  const current = typeof userOrRole === "string" ? userOrRole : userOrRole?.role;
  return normalizeRole(current) === normalizeRole(role);
}

export function hasAnyRole(userOrRole, roles) {
  const current = typeof userOrRole === "string" ? userOrRole : userOrRole?.role;
  const normalizedCurrent = normalizeRole(current);
  return Array.isArray(roles)
    ? roles.some((role) => normalizeRole(role) === normalizedCurrent)
    : false;
}
